export const SCHEMA_NAME = "Charges";

export const FIELDS = {
  CASE_NUMBER: "caseNumber",
  CHARGE_COUNT: "chargeCount",
  CHARGE_DESCRIPTION_ID: "chargeDescriptionID",
  CHARGE_LEVEL_ID: "chargeLevelID",
  CHARGE_MODIFIER_ID: "chargeModifierID",
  COMMENTS: "comments",
  CONTROLLING_AGENCY_ORI_ID: "controllingAgencyORIID",
  COURT_NUMBER: "courtNumber",
  ORIGINAL_CUSTODY_REASON_ID: "originalCustodyReasonID",
  TICKET_NUMBER: "ticketNumber",
  UCR_CODE: "UCRCode",
  WARRANT_NUMBER: "warrantNumber",
};
